import styled from "styled-components";
import { FLEX } from "styles/flex";
import { calcRem, isLight } from "styles/theme";

export const ModalRadioItem = styled.label<{
  isDisabled: boolean;
  checked: boolean;
}>`
  gap: 10px;
  width: 100%;
  cursor: pointer;
  border-radius: 10px;
  padding: 10px;

  border: 1px solid
    ${({ checked, theme }) =>
      checked
        ? theme.COLORS.SELECTED
        : `${theme.COLORS.WHITE}${isLight(theme) ? "20" : "40"}`};

  ${({ checked, theme }) =>
    checked &&
    `
    background-color:  ${
      isLight(theme)
        ? `${theme.COLORS.SELECTED}05`
        : `${theme.COLORS.SELECTED}20`
    };
    box-shadow: 0 0 0 1px ${theme.COLORS.SELECTED};
  `}
  .radio-item-checked-icon {
    width: 50px;
    height: 50px;
    border-radius: 10px;
    background-color: ${({ checked, theme, isDisabled }) => {
      if (checked) {
        return `${theme.COLORS.SELECTED}11`;
      }
      if (isDisabled) {
        return `${theme.COLORS.WHITE}08`;
      }
      return `${theme.COLORS.WHITE}11`;
    }};
    ${FLEX.FlexCenterCenter};
    font-size: ${calcRem(24)};
    color: ${({ checked, theme, isDisabled }) => {
      if (checked) {
        return theme.COLORS.SELECTED;
      }
      if (isDisabled) {
        return `${theme.COLORS.WHITE}30`;
      }
      if (isLight(theme)) {
        return `${theme.COLORS.WHITE}50`;
      }
      return `${theme.COLORS.WHITE}80`;
    }};
  }

  > input {
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    opacity: 0;
    visibility: hidden;
  }

  .report-item-content {
    flex: 1;
  }

  .report-radio-item {
    font-size: ${calcRem(16)};
    font-weight: 500;
    color: ${({ theme }) => theme.COLORS.WHITE};
  }

  .subtitle {
    padding-top: 4px;
    white-space: normal;
    line-height: 1.2;
    font-size: ${calcRem(13)};
    color: ${({ theme }) => theme.COLORS.WHITE}70;
  }

  ${({ isDisabled, theme }) =>
    isDisabled &&
    `
    background-color: ${theme.COLORS.WHITE}05;
    cursor: not-allowed;
    .report-item-content,
    .report-radio-item {
      opacity: 0.5;
    }
  `}

  .report-item-title {
    ${FLEX.FlexStartCenter};
    gap: 4px;
    color: ${({ theme }) => theme.COLORS.WHITE};

    button {
      ${FLEX.FlexCenterCenter};
      position: relative;

      .bubble-container {
        top: 30px;
      }
    }
  }
`;
